<template>
	<div
		class="calendar-container"
		ref="calendarContainer"
		:style="style()"
		tabindex="0"
	>
		<div class="calendar ms-dropdown">
			<div class="calendar-header-v2" ref="calendarHeader">
				<div
					class="calendar-header-select"
					:class="[
						{
							'w-full': typeDateSelect === $ms.enum.DatePickerTypeSelect.Year,
						},
					]"
				>
					<div
						class="pre-month"
						@click.stop="previousYear"
						v-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Year"
					>
						<div class="mi mi-24 mi-icon-pre-page"></div>
					</div>
					<div
						class="calender-current-date-v2 flex-1"
						:class="[
							{
								'selected-year-v2':
									typeDateSelect === $ms.enum.DatePickerTypeSelect.Year,
							},
						]"
						@click.stop="selectYearOld"
					>
						<span
							v-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Month"
							>{{ currentMonthText }}</span
						>
						<span
							v-else-if="
								typeDateSelect === $ms.enum.DatePickerTypeSelect.Quarter
							"
							>{{ currentQuarterText }}</span
						>
						<span v-else>{{ selectedYear }}</span>
					</div>
					<div
						class="next-month"
						@click="nextYear"
						v-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Year"
					>
						<div class="mi mi-24 mi-icon-next-page"></div>
					</div>
				</div>
			</div>

			<div
				class="calendar-month-select"
				v-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Month"
			>
				<table class="w-full">
					<transition-group name="slide-fade" tag="tbody" class="grid-month">
						<td
							class="month"
							v-for="(month, index) in monthMap"
							:id="`month-${month.value}`"
							:class="[
								{
									'ms-datepicker-year-selected': month.value == currentMonth,
								},
								{ selected: month.value == currentMonth },
							]"
							:key="index"
							@keydown.esc="onClose"
							@click.stop="setByMonth(month)"
						>
							{{ $i18n.locale === 'vi' ? month.name : month.nameEn }}
						</td>
					</transition-group>
				</table>
			</div>
			<div
				class="calendar-quarter-select"
				v-else-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Quarter"
			>
				<table class="w-full">
					<transition-group name="slide-fade" tag="tbody" class="grid-quarter">
						<td
							class="quarter"
							v-for="(quarter, index) in quarterMap"
							:id="`quarter-${quarter.value}`"
							:class="[
								{
									'ms-datepicker-year-selected':
										quarter.value == currentQuarter,
								},
								{ selected: quarter.value == currentQuarter },
							]"
							:key="index"
							@keydown.esc="onClose"
							@click.stop="setByQuarter(quarter)"
						>
							{{ $i18n.locale === 'vi' ? quarter.name : quarter.nameEn }}
						</td>
					</transition-group>
				</table>
			</div>
			<div
				class="calendar-year"
				v-else-if="typeDateSelect === $ms.enum.DatePickerTypeSelect.Year"
			>
				<table class="w-full">
					<transition-group name="slide-fade" tag="tbody" class="table-year">
						<tr
							v-for="(yearList, rowIndex) in years"
							:key="`row-${rowIndex}`"
							class="w-full grid-year"
						>
							<td
								class="item-year"
								v-for="(year, colIndex) in yearList"
								:class="{ selected: year.selected }"
								:id="`${year.year}-calendar-year`"
								:key="`col-${colIndex}`"
								@click.stop="setByYear(year.year, true)"
							>
								<div
									:class="[
										'ms-datepicker-year',
										{ 'ms-datepicker-year-selected': year.selected },
									]"
								>
									{{ year.year }}
								</div>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			<div
				class="calendar-year-select-v3"
				v-show="
					showChooseYear &&
					(typeDateSelect === $ms.enum.DatePickerTypeSelect.Month ||
						typeDateSelect === $ms.enum.DatePickerTypeSelect.Quarter)
				"
			>
				<div class="calender-current-year-v3 flex-1">
					<div class="pre-month" @click.stop="previousYear">
						<div class="mi mi-24 mi-icon-pre-page"></div>
					</div>
					<div
						class="calender-current-year-select-v2"
						@click.stop="selectYearOld"
					>
						<span>{{ currentYear }}</span>
					</div>
					<div class="next-month" @click.stop="nextYear">
						<div class="mi mi-24 mi-icon-next-page"></div>
					</div>
				</div>
				<!-- <div class="arrow-down"></div> -->
				<div class="separate-line"></div>

				<div class="calendar-year">
					<table class="w-full">
						<transition-group name="slide-fade" tag="tbody" class="table-year">
							<tr
								v-for="(yearList, rowIndex) in years"
								:key="`row-${rowIndex}`"
								class="w-full grid-year-2"
							>
								<td
									class="item-year"
									v-for="(year, colIndex) in yearList"
									:class="{ selected: year.selected }"
									:id="`${year.year}-calendar-year`"
									:key="`col-${colIndex}`"
									@click.stop="setByYear(year.year)"
								>
									<div
										:class="[
											'ms-datepicker-year',
											{ 'ms-datepicker-year-selected': year.selected },
										]"
									>
										{{ year.year }}
									</div>
								</td>
							</tr>
						</transition-group>
					</table>
				</div>
				<div class="separate-line"></div>
				<div class="flex items-center justify-end footer-button">
					<ms-button
						:title="$t('i18nCommon.Back')"
						class="btn-size btn-cancel"
						type="secondary"
						@click.stop="setSelecting(false)"
					></ms-button>
					<ms-button
						:title="$t('i18nCommon.Save2')"
						class="btn-size btn-save ml-2"
						type="primary"
						@click.stop="saveSelecting"
					></ms-button>
				</div>
			</div>

			<!-- <div class="calendar-footer">
				<button class="pick-today-button" @click.stop.prevent="onNow">
					{{ $t('i18nCommon.ToDay') }}
				</button>
			</div> -->
		</div>
	</div>
</template>

<script>
/* --------------------------------
 * Hàm tách mảng
 */
const slice = (array, start, end) => {
	let length = array == null ? 0 : array.length;

	if (!length) {
		return [];
	}

	start = start == null ? 0 : start;

	end = end === undefined ? length : end;

	if (start < 0) {
		start = -start > length ? 0 : length + start;
	}

	end = end > length ? length : end;

	if (end < 0) {
		end += length;
	}

	length = start > end ? 0 : (end - start) >>> 0;
	start >>>= 0;

	let index = -1;

	const result = new Array(length);

	while (++index < length) {
		result[index] = array[index + start];
	}

	return result;
};
/** -----------------------------
 * Hàm tách mảng thành nhiều mảng nhỏ có độ dài cho trước
 * @param {arrays, size}
 * -------------------------------
 */
const chunk = (array, size) => {
	size = Math.max(size, 0);

	const length = array == null ? 0 : array.length;

	if (!length || size < 1) {
		return [];
	}

	let index = 0;

	let resIndex = 0;

	const result = new Array(Math.ceil(length / size));

	while (index < length) {
		result[resIndex++] = slice(array, index, (index += size));
	}

	return result;
};

// @ is an alias to /src
import msBaseComponentDefaultVue from '@/components/msbase/msBaseComponentDefault.vue';
export default {
	name: 'datepicker',
	extends: msBaseComponentDefaultVue,
	data() {
		let dteNow = new Date();

		return {
			// hour: `${this.getTime() ? this.getTime()[0] : '00'}`,
			// min: `${this.getTime() ? this.getTime()[1] : '00'}`,
			// second: `${this.getTime() ? this.getTime()[2] : '00'}`,
			hour: 0,
			min: 0,
			second: 0,
			dayMap: {
				0: 'T2',
				1: 'T3',
				2: 'T4',
				3: 'T5',
				4: 'T6',
				5: 'T7',
				6: 'CN',
			},
			monthMap: [
				{
					name: 'Tháng 1',
					nameEn: 'January',
					value: 0,
				},
				{
					name: 'Tháng 2',
					nameEn: 'February',
					value: 1,
				},
				{
					name: 'Tháng 3',
					nameEn: 'March',
					value: 2,
				},
				{
					name: 'Tháng 4',
					nameEn: 'April',
					value: 3,
				},
				{
					name: 'Tháng 5',
					nameEn: 'May',
					value: 4,
				},
				{
					name: 'Tháng 6',
					nameEn: 'June',
					value: 5,
				},
				{
					name: 'Tháng 7',
					nameEn: 'July',
					value: 6,
				},
				{
					name: 'Tháng 8',
					nameEn: 'August',
					value: 7,
				},
				{
					name: 'Tháng 9',
					nameEn: 'September',
					value: 8,
				},
				{
					name: 'Tháng 10',
					nameEn: 'October',
					value: 9,
				},
				{
					name: 'Tháng 11',
					nameEn: 'November',
					value: 10,
				},
				{
					name: 'Tháng 12',
					nameEn: 'December',
					value: 11,
				},
			],
			quarterMap: [
				{
					name: 'Quý 1',
					nameEn: 'Quarter I',
					value: 1,
				},
				{
					name: 'Quý 2',
					nameEn: 'Quarter II',
					value: 2,
				},
				{
					name: 'Quý 3',
					nameEn: 'Quarter III',
					value: 3,
				},
				{
					name: 'Quý 4',
					nameEn: 'Quarter IV',
					value: 4,
				},
			],
			currentMonth: `${dteNow.getMonth()}`, // tháng 6
			currentQuarter: `${this.getCurrentQuarter()}`, // quý 2
			currentYear: `${dteNow.getFullYear()}`,
			selectedDayRange: [],
			selectedDayOfWeek: '',
			selectedDay: dteNow.getDate(),
			selectedQuater: `${this.getCurrentQuarter()}`,
			selectedMonth: `${dteNow.getMonth()}`,
			selectedYear: `${dteNow.getFullYear()}`,
			rangeDayMode: false, // chế độ khoảng thời gian, mặc định là không bật
			height: '',
			width: '',
			typeDateSelect: this.$ms.enum.DatePickerTypeSelect.Month,
			keyToDate: this.$ms.enum.KeyDate.StartDate,
			showChooseYear: false,
			years: [],
		};
	},
	watch: {
		// time(value) {
		// 	this.hour = `${this.getTime() ? this.getTime()[0] : '00'}`;
		// 	this.min = `${this.getTime() ? this.getTime()[1] : '00'}`;
		// 	this.second = `${this.getTime() ? this.getTime()[2] : '00'}`;
		// },
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal && newVal instanceof Date) {
					me.hour = newVal.getHours();
					me.min = newVal.getMinutes();
					me.second = newVal.getSeconds();
				}
			},
		},
	},
	props: {
		hasTime: {
			type: Boolean,
			default: false,
		},
		// time: {
		// 	type: String,
		// 	default: new Date().getHours() + ':' + new Date().getMinutes()
		// },
		colorSelected: {
			type: String,
			required: false,
			default: '#08BF1E',
		},
		backgroundSelected: {
			type: String,
			required: false,
			default: 'rgba(44, 160, 28, 0.2)',
		},
		yearSelected: {
			type: String,
			required: false,
			default: '#fff',
		},
		value: {},

		screenX: {
			type: Number,
			required: true,
		},
		screenY: {
			type: Number,
			required: true,
		},
		minDate: {},
		maxDate: {},
		customProperty: {},
	},
	methods: {
		getCurrentQuarter() {
			const me = this;
			if (me.value) {
				const month = new Date(me.value).getMonth() + 1;
				return Math.ceil(month / 3);
			}
			const month = new Date().getMonth(); // Lấy tháng hiện tại (0-11)
			return Math.floor(month / 3) + 1; // Chia cho 3 và làm tròn xuống, sau đó cộng 1
		},
		initDataStatic() {
			const me = this;
			me.showChooseYear = false;
			me.typeDateSelect =
				me.customProperty && me.customProperty.typeDateSelect >= 0
					? me.customProperty.typeDateSelect
					: me.$ms.enum.DatePickerTypeSelect.Month;
			me.keyToDate =
				me.customProperty && me.customProperty.keyToDate
					? me.customProperty.keyToDate
					: me.$ms.enum.KeyDate.StartDate;
			me.calcYears();
		},
		checkMinDate(day) {
			if (this.minDate) {
				if (this.selectedYear < this.minDate.getFullYear()) {
					return true;
				}
				if (this.selectedYear > this.minDate.getFullYear()) {
					return false;
				}
				if (this.currentMonth < this.minDate.getMonth()) {
					return true;
				}
				if (
					this.currentYear == this.minDate.getFullYear() &&
					this.currentMonth == this.minDate.getMonth() &&
					day.day < this.minDate.getDate()
				) {
					return true;
				}
			}
			return false;
		},
		checkMaxDate(day) {
			if (this.maxDate) {
				if (this.selectedYear > this.maxDate.getFullYear()) {
					return true;
				}
				if (this.currentMonth > this.maxDate.getMonth()) {
					return true;
				}
				if (
					this.currentYear == this.maxDate.getFullYear() &&
					this.currentMonth == this.maxDate.getMonth() &&
					day.day > this.maxDate.getDate()
				) {
					return true;
				}
			}
			return false;
		},
		onInputHour() {
			// hàm này kiểm tra focus sang input min
			const me = this,
				hour = me.hour;
			if (
				(hour.toString().length === 1 && hour >= 3) ||
				hour.toString().length === 2
			) {
				me.updateTime(hour, null, null);
			}
		},

		onInputMin() {
			const me = this,
				min = me.min;
			if (
				(min.toString().length === 1 && min >= 6) ||
				min.toString().length === 2
			) {
				me.updateTime(null, min, null);
			}
		},

		onInputSecond() {
			const me = this,
				second = me.second;

			if (
				(second.toString().length === 1 && second >= 6) ||
				second.toString().length === 2
			) {
				//update ra ngoai
				me.updateTime(null, null, second);
			}
		},

		updateHour() {
			this.updateTime(this.hour, null, null);
		},

		updateMin() {
			this.updateTime(null, this.min, null);
		},

		updateSecond() {
			this.updateTime(null, null, this.second);
		},

		/**
		 * Thực hiện cập nhật Giờ/Phút/Giây
		 */
		updateTime(hour, min, second) {
			const me = this;

			let valueDateTime = me.value;
			if (valueDateTime && valueDateTime instanceof Date) {
				if (hour) {
					valueDateTime.setHours(hour);
				}
				if (min) {
					valueDateTime.setMinutes(min);
				}
				if (second) {
					valueDateTime.setSeconds(second);
				}

				this.$emit('input', valueDateTime);
			}
		},

		style() {
			//Chieu cao cua cua so
			let height =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			let width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			let top = 36 + 'px';

			//this.screenY laf vi tri cua
			if (this.screenY + this.height + 100 > height) {
				top = -this.height - 36 + 'px';
			}
			if (this.screenX - this.width < 200) {
				return {
					left: 0 + 'px',
					top: top,
				};
			} else
				return {
					right: 0 + 'px',
					top: top,
				};
		},

		/**
		 * Changes the display to the calendar or years depending on the value.
		 */
		/*---------------------------------
		 * Hàm trả về tháng tiếp theo (hoặc 12 năm tiếp theo) khi bấm mũi tên sang phải (hoặc lên trên)
		 * Created by: nvlam (22/06/2019)
		 */
		nextYear() {
			const me = this;
			me.years.forEach((items) => {
				items.forEach((item) => {
					item.year += 12;
					item.selected = me.selectedYear === item.year;
				});
			});
		},

		/*---------------------------------
		 * Hàm trả về tháng trước (hoặc 12 năm về trước) khi bấm mũi tên sang phải (hoặc xuống dưới)
		 * Created by: nvlam (22/06/2019)
		 */
		previousYear() {
			const me = this;
			me.years.forEach((items) => {
				items.forEach((item) => {
					item.year -= 12;
					item.selected = me.selectedYear === item.year;
				});
			});
		},

		selectYearOld() {
			const me = this;
			// if (me.typeDateSelect !== me.$ms.enum.DatePickerTypeSelect.Year) return;
			// this.currentYear = this.selectedYear;
			// me.calcYears();
			// me.years.forEach((items) => {
			// 	items.forEach((item) => {
			// 		item.selected = me.currentYear === item.year;
			// 	});
			// });
		},

		/*---------------------------------
		 * Đóng lịch khi các nút Esc hay Tab được nhấn
		 * Created by: nvlam (22/06/2019)
		 */
		setEscapeEvent() {
			const me = this;
			document.addEventListener('keydown', me.eventEscape);
		},

		eventEscape(event) {
			const me = this;
			event.stopPropagation();
			event.preventDefault();
			if (event.keyCode == 27 || event.key == 'Escape' || event.key == 'Tab') {
				event.cancel = true;
				me.onClose({
					event: event,
					isSave: false,
				});
			}
		},

		/**
		 * Set the date by the given day.
		 *
		 * @param {Object}
		 */
		setByDay(day) {
			const me = this;
			if (!day.day) return;
			// if (day.disabled) return;
			if (me.rangeDayMode == false) {
				// me.currentYear = me.selectedYear;
				me.selectedDay = day.day;
				me.selectedMonth = me.currentMonth;
				me.selectedDayOfWeek = new Date(
					me.currentYear,
					me.selectedMonth,
					day.day
				).getDay();
			}

			let valueDateTime = me.value;
			if (valueDateTime && valueDateTime instanceof Date) {
				valueDateTime.setYear(me.selectedYear);
				valueDateTime.setMonth(me.selectedMonth, day.day);
			}

			me.$emit('selected', new Date(valueDateTime));

			me.onClose({
				event: event,
				isSave: true,
			});
			// this.onInput();
		},

		getDateOrder(year) {
			const me = this;
			let date = new Date();
			if (me.typeDateSelect === me.$ms.enum.DatePickerTypeSelect.Month) {
				if (me.keyToDate === me.$ms.enum.KeyDate.StartDate) {
					date = new Date(year, me.selectedMonth, 1);
				} else {
					date = new Date(year, me.selectedMonth + 1, 0);
				}
			} else if (
				me.typeDateSelect === me.$ms.enum.DatePickerTypeSelect.Quarter
			) {
				if (me.keyToDate === me.$ms.enum.KeyDate.StartDate) {
					date = new Date(year, me.selectedQuater * 3 - 3, 1);
				} else {
					date = new Date(year, me.selectedQuater * 3, 0);
				}
			} else {
				if (me.keyToDate === me.$ms.enum.KeyDate.StartDate) {
					date = new Date(year, 0, 1); //Ngày đầu tiên của năm
				} else {
					date = new Date(year + 1, 0, 0); // Ngày cuối cùng của năm
				}
			}
			return date;
		},

		setDateValue(date, isChooseFormYear = false) {
			const me = this;
			me.selectedDay = date.getDate();
			me.selectedMonth = date.getMonth();
			me.currentMonth = date.getMonth();
			if (isChooseFormYear) {
				me.currentYear = date.getFullYear();
			}
			me.selectedYear = date.getFullYear();
			me.selectedDayOfWeek = date.getDay();
		},

		setByYear(year, isChooseFormYear = false) {
			const me = this;
			let date = me.getDateOrder(year);
			me.setDateValue(date, isChooseFormYear);
			if (me.hasTime) {
				me.min = date.getMinutes();
				me.hour = date.getHours();
				me.second = date.getSeconds();
				me.updateTime(me.hour, me.min, me.second);
			}
			if (isChooseFormYear) {
				me.setByDay({
					currentDay: true,
					day: me.selectedDay,
					selected: true,
				});
			} else {
				me.years.forEach((items) => {
					items.forEach((item) => {
						item.selected = year === item.year;
					});
				});
			}
			// me.onClose(event);
		},

		saveSelecting() {
			const me = this;
			if (!me.years || me.years.length <= 0) return;
			let year = me.years.flat().find((item) => item.selected);
			if (year && year.year) {
				me.setByYear(year.year, true);
			} else {
				me.setByYear(me.selectedYear, true);
			}
		},

		setByMonth(month) {
			const me = this;
			const date = new Date(me.currentYear, month.value, 1);

			me.selectedDay = date.getDate();
			me.selectedMonth = date.getMonth();
			me.selectedYear = date.getFullYear();
			me.selectedDayOfWeek = date.getDay();
			me.currentMonth = date.getMonth();
			me.setSelecting(true);
			me.calcYears();
		},

		setByQuarter(quarter) {
			const me = this;
			me.selectedQuater = quarter.value;
			me.setSelecting(true);
			me.calcYears();
		},

		onBlur(e) {
			this.onClose({
				event: e,
				isSave: false,
			});
		},

		/**
		 * Emit a close event so the developer can close the date picker as they
		 * see fit.
		 */
		onClose(data) {
			// this.hideBodyOverflow(false);

			this.$emit('close', data);
		},

		closeOut(e) {
			const me = this;
			if (
				!e.target.closest('.calendar') &&
				(!e.target.closest('.ms-datepicker') ||
					e.target.closest('.ms-datepicker') != me.$parent.$el)
			) {
				me.onClose({
					event: e,
					isSave: false,
				});
			}
		},
		/*--------------------------------
		 * Bật chế độ chọn khoảng ngày
		 * Created by: nvlam(26/06/2019)
		 */
		onRangeDayMode() {
			this.rangeDayMode = true;
			return this.rangeDayMode;
		},

		/*--------------------------------
		 * Tắt chế độ chọn khoảng ngày
		 * Created by: nvlam(26/06/2019)
		 */
		offRangeDayMode() {
			this.rangeDayMode = false;
			return this.rangeDayMode;
		},

		/*---------------------------------
		 * Hàm thay đổi chế độ chọn năm hoặc chọn ngày
		 * Created by: nvlam(24/06/2019)
		 */
		setSelecting(showChooseYear = false) {
			const me = this;
			if (
				me.typeDateSelect === me.$ms.enum.DatePickerTypeSelect.Month ||
				me.typeDateSelect === me.$ms.enum.DatePickerTypeSelect.Quarter
			) {
				me.showChooseYear = showChooseYear;
			}
			me.currentYear = me.selectedYear;
		},

		/**
		 * Lấy ngày cho datepicker khi nhập từ ô input.
		 */
		setDate() {
			// Nếu ngày được truyền tới component datepicker, nó sẽ được dùng
			// thay cho ngày hiện tại.
			let date;

			if (this.min && this.min && !this.value) {
				date = new Date();
			} else if (this.value && this.value) {
				date = new Date(this.value);
			} else {
				date = new Date();
			}
			// if (this.initialDate) {
			//     this.selectedDay = date.getDate();
			// } else {
			//     this.selectedDay = date.getDate();
			// }
			this.selectedDay = date.getDate();
			this.selectedDayOfWeek = date.getDay();
			this.selectedMonth = date.getMonth();
			this.currentMonth = date.getMonth();
			this.selectedYear = date.getFullYear();
			this.currentYear = date.getFullYear();
		},
		getMonthKey(currentMonth) {
			switch (currentMonth) {
				case 0:
					return 'January';
				case 1:
					return 'February';
				case 2:
					return 'March';
				case 3:
					return 'April';
				case 4:
					return 'May';
				case 5:
					return 'June';
				case 6:
					return 'July';
				case 7:
					return 'August';
				case 8:
					return 'September';
				case 9:
					return 'October';
				case 10:
					return 'November';
				case 11:
					return 'December';
			}
		},

		calcYears() {
			const me = this;
			//Đặt năm đầu tiên của dãy
			let lastYear;
			if (this.selectedYear === '') {
				lastYear = new Date().getFullYear();
			} else lastYear = this.currentYear;
			let through = 12; // số năm hiển thị trên 1 trang
			let years = []; // mảng chứa các năm
			for (let i = lastYear; i < lastYear + through; i++) {
				years.push(i);
			}
			const today = new Date();
			const yearObjects = years.map((year) => {
				const currentYear = this.selectedYear === today.getFullYear();
				const selected =
					this.selectedYear === year &&
					this.currentMonth === this.selectedMonth;
				// const disabled = this.dayDisabled(day);

				// return { day, currentDay, selected, disabled };
				return { year, currentYear, selected };
			});

			// Chunk all of the days into an array of arrays, by seven.
			me.years = chunk(yearObjects, 4);
		},
	},
	computed: {
		/* --------------------------------
		 * Hàm trả về một mảng gồm ngày của tuần đầu tiên trong tháng của năm
		 * VD: Nếu ngày 1 trong tháng bắt đầu từ thứ 6
		 * thì mảng sẽ là ['', '', '', '', '', '1', '2']
		 * Created by: nvlam (22/06/2019)
		 */
		calendar() {
			const days = [];
			//Lấy ra thứ của ngày đầu tiên trong tháng
			const startDayOfMonth = new Date(
				this.selectedYear,
				this.currentMonth,
				1
			).getDay();
			let startDay = startDayOfMonth;
			if (startDayOfMonth != 0) {
				for (let i = 0; i < startDay - 1; i++) {
					days.push('');
				}
			} else {
				for (let i = 0; i < 6; i++) {
					days.push('');
				}
			}
			//Tạo mảng gồm các ngày còn lại trong tháng
			const daysInMonth =
				32 - new Date(this.selectedYear, this.currentMonth, 32).getDate();
			for (let i = 0; i < daysInMonth; i++) {
				days.push(i + 1);
			}

			// Map the days from numbers to objects that have current day,
			// selected, and disabled properties for the view.
			const today = new Date();

			const dayObjects = days.map((day) => {
				const currentDay =
					day === today.getDate() &&
					this.currentMonth == today.getMonth() &&
					this.selectedYear == today.getFullYear();
				const selected =
					this.selectedDay === day && this.currentMonth === this.selectedMonth;

				// const disabled = this.dayDisabled(day);

				// return { day, currentDay, selected, disabled };
				return { day, currentDay, selected };
			});

			// Chunk all of the days into an array of arrays, by seven.
			return chunk(dayObjects, 7);
		},

		/**
		 * Trả về tháng được chọn thành một từ.
		 * VD: 6 -> Tháng 6
		 *
		 * @return {String}
		 */
		selectedMonthWord() {
			return monthMap[this.selectedMonth];
		},
		selectedDateRange() {
			let beginDay = this.selectedDay;
			return beginDay;
		},
		currentMonthText() {
			let currentMonth = this.currentMonth;
			if (this.$i18n.isVietnamese) return `Tháng ${currentMonth + 1}`;
			else if (this.$i18n.isEnglish)
				return (
					this.$t(`i18nCommon.MonthInfo.${this.getMonthKey(currentMonth)}`) +
					' '
				);
		},
		currentQuarterText() {
			const me = this;
			let quarter = me.quarterMap.find((q) => q.value == me.currentQuarter);
			if (!quarter) return '';
			return me.$i18n.isVietnamese ? quarter.name : quarter.nameEn;
		},
	},
	getValueFromInput() {
		return (this.currentMonth = this.specifiedDate.getMonth());
	},
	created() {
		this.setEscapeEvent();
		this.setDate();
		document.addEventListener('mousedown', this.closeOut);
		this.initDataStatic();
	},
	destroyed() {
		const me = this;
		document.removeEventListener('mousedown', me.closeOut);
		document.removeEventListener('keydown', me.eventEscape);
	},
	mounted() {
		this.height = this.$el.offsetHeight;
		this.width = this.$el.offsetWidth;
	},
};
</script>
<style>
@import '../../assets/css/iconfont.css';
</style>

<style lang="scss" scoped>
@import '@/assets/scss/components/msDatePickerPopupV2.scss';
.disabled {
	opacity: 0.7;
	pointer-events: none;
}

.grid-month {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	padding: 0 8px 8px;
}
.month {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	cursor: pointer;
	&:hover {
		background-color: #fff;
		color: $ms-color-primary;
		border: 1px solid $ms-color-primary;
		border-radius: 20px;
	}
}

.calendar-year {
	width: 100%;
}

.table-year {
	display: block;
}

.grid-year {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	padding: 0 8px;
	height: 50px;
}

.grid-year-2 {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	padding: 0 8px;
	height: 40px;
	align-items: center;
}

.item-year {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	cursor: pointer;
	&:hover {
		color: $ms-color-primary;
	}
}

.calender-current-year {
	width: auto;
}
.calendar-year-select-v2 {
	position: absolute;
	top: 2%;
	left: 3%;
	display: flex;
	height: 94%;
	border-radius: 22px;
	width: 94%;
	background: $white;
	border: 1px solid $ms-border-color;
	transition: transform 0.2s ease-in, opacity 0.3s cubic-bezier(0, 0, 0.31, 1);
	animation: expand 0.2s;
	cursor: pointer;
}

.calendar-year-select-v2 table {
	width: 100%;
	height: 60%;
	margin: 15% 0;
	color: $ms-color-text-primary;
	font-weight: $ms-font-weight-medium;
	font-size: $font-size-body-new;
	position: absolute;
}

.calendar-year-select-v2 .cancel-button {
	background: none;
	border: none;
	color: $ms-color-text-primary;
	font-weight: $ms-font-weight-medium;
	cursor: pointer;
	position: absolute;
	bottom: 10%;
	left: 40%;
}

.calendar-year-select-v3 {
	position: absolute;
	top: 2%;
	left: 3%;
	height: 94%;
	border-radius: 22px;
	width: 94%;
	background: $white;
	border: 1px solid $ms-border-color;
	transition: transform 0.2s ease-in, opacity 0.3s cubic-bezier(0, 0, 0.31, 1);
	animation: expand 0.2s;
	cursor: pointer;
}

.calendar-year-select-v3 table {
	width: 100%;
	height: 100%;
	color: $ms-color-text-primary;
	font-weight: $ms-font-weight-medium;
	font-size: $font-size-body-new;
	position: absolute;
}

.calendar-year-select-v3 .cancel-button {
	background: none;
	border: none;
	color: $ms-color-text-primary;
	font-weight: $ms-font-weight-medium;
	cursor: pointer;
	position: absolute;
	bottom: 10%;
	left: 40%;
}
.calender-current-year-v2 {
	border-radius: 4px;
	padding: 4px;
	line-height: 24px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 6px 20px;
}

.calender-current-year-v3 {
	border-radius: 4px;
	padding: 4px;
	line-height: 24px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 6px 20px;
}

.grid-quarter {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
	padding: 0 8px 8px;
	height: 184px;
	align-content: flex-start;
}

.quarter {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	cursor: pointer;
	&:hover {
		background-color: #fff;
		color: $ms-color-primary;
		border: 1px solid $ms-color-primary;
		border-radius: 20px;
	}
}
.calendar-container .calendar-header-v2 {
	padding: 13px 30px 8px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
}

.calendar-container .calendar-header-v2 .calendar-header-select {
	width: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.calendar-container .calendar-header-v2 .icon-calendar-header {
	position: absolute;
	left: 30px;
	top: 17px;
	width: 20px;
	height: 20px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0, 0, 0.31, 1);
}

.calendar-container .calendar-header-v2 .left-icon:hover {
	left: 27px;
}

.calendar-container .calendar-header-v2 .right-icon {
	right: 30px;
	left: auto;
}

.calendar-container .calendar-header-v2 .right-icon:hover {
	right: 27px;
}

.calendar-container .calendar-header-v2 .calender-current-date {
	text-align: center;
	font-weight: $ms-font-weight-bold;
	cursor: pointer;
	margin: 0 8px;
}
.calender-current-date-v2 {
	background: $ms-color-neutral-200;
	border-radius: 4px;
	padding: 4px;
	line-height: 24px;
	height: 32px;
}

.selected-year-v2 {
	margin: 0 5%;
}
.calender-current-year-select-v2 {
	width: 100%;
	margin: 0 5%;
	height: 32px;
	background: #f3f4f7;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	border-radius: 4px;
}

.footer-button {
	height: 32px;
	position: absolute;
	bottom: 14px;
	width: 100%;
	right: 16px;
}
.btn-cancel,
.btn-save {
	width: 100px;
}
</style>



